import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Text from '@bit/knotchinc.web-react-components.text';
import Box from '@bit/knotchinc.web-react-components.box';
import Mixpanel from 'helpers/Mixpanel.js';
import { NoProductsPageContainer, ErrorContainer } from '../NoProductsPage/styled';

const ErrorPage = ({ error, errorStack, isKnotchAdmin }) => {
  Mixpanel.track('viewed Error page');
  return (
    <NoProductsPageContainer>
      <Box>
        <Text fontWeight="thin" fontSize="40px">Something went wrong...</Text>
        <Box mt="24px" mb="24px">
          <br />
          {isKnotchAdmin &&
          <React.Fragment>
            <Text color="#fb1359" fontSize="20px">{error}</Text>
            <ErrorContainer>
              <PerfectScrollbar>
                <div>
                  {errorStack}
                </div>
              </PerfectScrollbar>
            </ErrorContainer>
          </React.Fragment>}
        </Box>
        <a className="backtoMain" href="/blueprint">Click here to go back →</a>
      </Box>
    </NoProductsPageContainer>
  );
};

export default ErrorPage;
